import { Link } from 'react-router-dom';

export default function Hero() {
  const handleWhatsAppClick = () => {
    window.open('https://wa.me/258869689262?text=Olá! Gostaria de saber mais sobre os Crocs personalizados.', '_blank');
  };

  return (
    <section className="relative h-screen w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/059bef239d7b99f725201f3bb1413769/ac4ad87c53ff3631423f63068358dfeb.jpeg"
          alt="Crocs Personalizados com Pins Decorativos"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/60"></div>
      </div>

      <div className="relative h-full max-w-7xl mx-auto px-6 flex items-center justify-center">
        <div className="w-full text-center">
          <h1 className="text-8xl md:text-9xl font-bold text-white mb-8 leading-tight drop-shadow-2xl" style={{ textShadow: '0 0 40px rgba(0,0,0,0.8), 0 0 20px rgba(0,0,0,0.6)' }}>
            Mundo Crocs
          </h1>
          <p className="text-3xl md:text-4xl text-white mb-6 drop-shadow-lg font-bold" style={{ textShadow: '0 0 30px rgba(0,0,0,0.8)' }}>
            Crocs Personalizados em Moçambique
          </p>
          <p className="text-xl md:text-2xl text-white mb-12 drop-shadow-lg font-semibold" style={{ textShadow: '0 0 20px rgba(0,0,0,0.8)' }}>
            Estilo único com pins decorativos • Conforto garantido • 1.800 MZN
          </p>
          <div className="flex gap-4 justify-center flex-wrap">
            <button
              onClick={handleWhatsAppClick}
              className="inline-flex items-center gap-3 px-12 py-6 bg-green-500 text-white text-xl font-bold rounded-full hover:bg-green-600 hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-xl"
            >
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-whatsapp-line text-2xl"></i>
              </div>
              Comprar no WhatsApp
            </button>
            <a
              href="#produtos"
              className="inline-flex items-center gap-3 px-12 py-6 bg-white text-gray-900 text-xl font-bold rounded-full hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-xl"
            >
              Ver Modelos
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-arrow-down-line text-xl"></i>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
